<template>
	<div class="official-recommend-page">
		<div class="msg-center-nav">
			<div class="msg-categories">
				<div v-for="category in categories" :key="category.key" class="category-item"
					:class="{ 'active': activeCategory === category.key }" @click="switchCategory(category.key)">
					{{ category.name }}
				</div>
			</div>
			<div class="publish" @click="$router.push('/piblish')">发布作品</div>
		</div>
		<div class="filterBox">
			<div class="filterItem">
				<div class="filterItemTitle">类型：</div>
				<div class="filterItemList">
					<div class="tip" :class="cid == '' ? 'active' : ''" @click="changeFilter('cid','')">全部</div>
					<div class="tip" :class="cid == item.id ? 'active' : ''" v-for="(item,index) in typeOpts"
						:key="index" @click="changeFilter('cid',item.id)">{{item.title}}</div>
				</div>
			</div>
			<div class="filterItem">
				<div class="filterItemTitle">用途：</div>
				<div class="filterItemList">
					<div class="tip" :class="yongtu == '' ? 'active' : ''" @click="changeFilter('yongtu','')">全部
					</div>
					<div class="tip" :class="yongtu == item.id ? 'active' : ''" v-for="(item,index) in yongtuOpts"
						:key="index" @click="changeFilter('yongtu',item.id)">{{item.title}}</div>
				</div>
			</div>
			<div class="filterItem">
				<div class="filterItemTitle">可购身份：</div>
				<div class="filterItemList">
					<div class="tip" :class="level == '' ? 'active' : ''" @click="changeFilter('level','')">全部</div>
					<div class="tip" :class="level == item.id ? 'active' : ''" v-for="(item,index) in levelOpts"
						:key="index" @click="changeFilter('level',item.id)">{{item.title}}</div>
				</div>
			</div>
			<div class="filterItem">
				<div class="filterItemTitle">图片属性：</div>
				<div class="filterItemList">
					<div class="tip" :class="shuxing == item.title ? 'active' : ''"
						v-for="(item,index) in imgAttributeOpts" :key="index"
						@click="changeFilter('shuxing',item.title)">
						{{item.title}}
					</div>
				</div>
			</div>
			<div class="filterItem">
				<div class="filterItemTitle">排列方式：</div>
				<div class="filterItemList">
					<div class="tip" :class="px == item.value ? 'active' : ''" v-for="(item,index) in sortOpts"
						:key="index" @click="changeFilter('px',item.value)">{{item.title}}</div>
				</div>
			</div>
			<div class="filterItem">
				<div class="filterItemTitle">上架类型：</div>
				<div class="filterItemList">
					<div class="tip" :class="sj == item.value ? 'active' : ''" v-for="(item,index) in listingTypeOpts"
						:key="index" @click="changeFilter('sj',item.value)">{{item.title}}</div>
				</div>
			</div>
		</div>
		<div class="chooseBox">
			<div class="choose" v-if="!checkAll" @click="changeAllWork(true)">全选</div>
			<div class="choose" v-else @click="changeAllWork(false)">取消全选</div>
			<div class="watermark" v-if="checkAll" @click="dialogReportVisible = true">一键水印 <img class="arrow"
					src="../../assets/MyOrder/iconD.png" /></div>
		</div>
		<div class="officialList" v-if="data.length">
			<div class="workItem" v-for="(item,index) in data" :key="index">
				<div class="wokItemLeft">
					<img class="checkImg" src="../../assets/Register/checkSel.png" v-if="checkAll && item.check"
						@click="item.check = false" />
					<img class="checkImg" src="../../assets/Register/checkNor.png" v-if="checkAll && !item.check"
						@click="item.check = true" />
					<div class="workImgBox">
						<img class="workImg" :src="item.img" />
						<img class="bestIcon" src="../../assets/Home/best.png" v-if="item.shuxing == '精品图'" />
					</div>
					<div class="workInfoBox">
						<div class="title">
							{{item.title}}
							<div class="topBox" :class="item.zd_status == 2 ? 'topBoxNor' : 'topBoxOth'"
								@click="topWork(1,item)">
								<img class="topIcon" src="../../assets/Painter/iconN.png" v-if="item.zd_status == 2" />
								<img class="topIcon" src="../../assets/Painter/iconP.png" v-if="item.zd_status == 1" />
								置顶
							</div>
							<div class="topBox" :class="item.db_status == 2 ? 'topBoxNor' : 'topBoxSel'"
								@click="topWork(2,item)">
								<img class="topIcon" src="../../assets/Painter/iconM.png" v-if="item.db_status == 2" />
								<img class="topIcon" src="../../assets/Painter/iconO.png" v-if="item.db_status == 1" />
								代表作品
							</div>
						</div>
						<div class="desc ellipsis-2">
							{{item.content}}
						</div>
						<div class="tips">
							<div class="tip" v-if="item.cid">{{item.cid}}</div>
							<div class="tip" v-for="(tip,tipIndex) in item.yongtu" :key="tipIndex">{{tip}}</div>
							<div class="zanNum">点赞：{{item.zan_count}}</div>
						</div>
					</div>
				</div>
				<div class="menu">
					<div class="menuItem edit" v-if="activeCategory == '1'" @click="naviToEdit(item)">编辑</div>
					<div class="menuItem details"
						v-if="activeCategory == '1' || activeCategory == '2' || activeCategory == '4'"
						@click="$router.push({path: '/painter-works-details',query: {id:item.id,userId: item.user_id}})">
						查看详情</div>
					<div class="menuItem launch" v-if="activeCategory == '2'" @click="changeGoodsStatus(item)">上架</div>
					<div class="menuItem launch" v-if="activeCategory == '1'" @click="changeGoodsStatus(item)">下架</div>
					<div class="menuItem reEdit" v-if="activeCategory == '3'" @click="naviToEdit(item)">重新编辑</div>
					<div class="menuItem delete" v-if="activeCategory == '2' || activeCategory == '3'"
						@click="deleteGoods(item)">删除</div>
					<div class="menuItem launch" v-if="activeCategory == '4'" @click="hiddenWork(item)">
						{{item.yc_status == 1 ? '主页隐藏' : '主页展示'}}
					</div>
				</div>
			</div>
		</div>
		<el-empty description="暂无数据" v-else></el-empty>
		<!-- 分页控件 -->
		<PagePagination :currentPage="currentPage" style="padding: .32rem 0 .4rem;" :total="total"
			@current-change="onPageChange" />

		<el-dialog class="reportDialog" :visible.sync="dialogReportVisible" append-to-body @close="closeReply">
			<div slot="title">
				<div class="dislogTitle">
					一键水印设置
				</div>
			</div>
			<div class="dislogConent">
				<el-form ref="ruleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
					<el-form-item label="位置设置：" prop="sy_wz">
						<el-select v-model="ruleForm.sy_wz" class="inputBox" placeholder="请选择位置" clearable>
							<el-option v-for="item in positionOpts" :key="item.id" :label="item.name"
								:value="item.value" />
						</el-select>
					</el-form-item>
					<el-form-item label="水印选择：" prop="shuiyin">
						<div class="imgList">
							<div class="imgItem" v-for="(item,index) in shuiYinOpts" :key="index"
								@click="checkWater(item)">
								<div class="imgBox">
									<img class="waterImg" :src="item.img" />
									{{item.title}}
								</div>
								<img class="checkImg" src="../../assets/Painter/iconQ.png" v-if="item.check" />
								<img class="checkImg" src="../../assets/Painter/iconR.png" v-if="!item.check" />
							</div>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button class="submit" type="primary" size="medium"
						@click="submitForm('ruleForm')">确认</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'PainterWorks',
		data() {
			return {
				ruleForm: {
					id: '',
					sy_wz: '',
					shuiyin: '',
				},
				rules: {
					sy_wz: [{
						required: true,
						message: '请选择位置',
						trigger: 'blur'
					}],
					shuiyin: [{
						required: true,
						message: '请选择水印',
						trigger: 'blur'
					}],
				},
				dialogReportVisible: false,
				checkAll: false,
				// 分类导航
				categories: [{
						key: '1',
						name: '上架作品'
					},
					{
						key: '2',
						name: '下架作品'
					},
					{
						key: '3',
						name: '审核驳回'
					},
					{
						key: '4',
						name: '已售作品'
					}
				],
				curOrder: {},
				orderData: [],
				activeCategory: '1',
				data: [],
				keywords: '', //关键词
				shuxing: '默认',
				imgAttributeOpts: [{
					title: '默认',
					value: '0'
				}, {
					title: '精品图',
					value: '1'
				}, {
					title: '普通图',
					value: '2'
				}],
				px: '',
				sortOpts: [{
					title: '默认',
					value: ''
				}, {
					title: '最新发布',
					value: '1'
				}, {
					title: '最多点赞',
					value: '2'
				}, {
					title: '价格升序',
					value: '3'
				}, {
					title: '价格降序',
					value: '4'
				}], // {title: '综合排序',value: '5'}
				sj: '',
				listingTypeOpts: [{
					title: '默认',
					value: ''
				}, {
					title: '限制购买',
					value: '1'
				}, {
					title: '非限制购买',
					value: '2'
				}],
				cid: '', //分类
				typeOpts: [],
				yongtu: '', //用途
				yongtuOpts: [],
				level: '',
				shuiYinOpts: [],
				positionOpts: [{
						id: 1,
						name: '左上',
						value: 'nw'
					},
					{
						id: 2,
						name: '中上',
						value: 'north'
					},
					{
						id: 3,
						name: '右上',
						value: 'ne'
					},
					{
						id: 4,
						name: '左中',
						value: 'west'
					},
					{
						id: 5,
						name: '中部',
						value: 'center'
					},
					{
						id: 6,
						name: '右中',
						value: 'east'
					},
					{
						id: 7,
						name: '左下',
						value: 'sw'
					},
					{
						id: 8,
						name: '中下',
						value: 'south'
					},
					{
						id: 9,
						name: '右下',
						value: 'se'
					},
				],
				levelOpts: [],
				currentPage: 1, // 当前页码
				total: 0, // 总条数
			}
		},
		created() {
			this.$on("refreshList", () => {
				this.goodsHuaList()
			})
		},
		destroyed() {
			this.$off("refreshList");
		},
		mounted() {
			this.shuiyinList()
			this.goodsHuaList()
			this.basicsVipList()
			this.basicsLabelList()
			this.basicsClassifyList()
		},
		methods: {
			closeReply() {
				this.dialogReplyViable = false
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post('/Hua/one_watermark', {
							id: this.data.map(item => {
								if (item.check) {
									return item.id
								}
							}).join(','),
							shuiyin: this.ruleForm.shuiyin,
							sy_wz: this.ruleForm.sy_wz,
						}).then(res => {
							this.checkAll = false
							this.dialogReportVisible = false
							if (res.code == 1) {
								this.$message.success(res.msg)
							} else {
								this.$message.error(res.msg)
							}
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			},
			topWork(type, item) {
				this.$api.post('/Hua/top_work', {
					id: item.id,
					type: type,
				}).then(res => {
					if (res.code == 1) {
						this.goodsHuaList()
						this.$message.success(res.msg)
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			hiddenWork(item) {
				this.$confirm(`确认${item.yc_status == 1 ? '主页隐藏' : '主页展示'}商品吗?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/Hua/yc_work', {
						id: item.id
					}).then(res => {
						if (res.code == 1) {
							this.goodsHuaList()
							this.$message.success(res.msg)
						} else {
							this.$message.error(res.msg)
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(err => {
					console.log(err);
				});
			},
			deleteGoods(item) {
				this.$confirm('确认删除商品吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/Hua/yc_work', {
						id: item.id
					}).then(res => {
						if (res.code == 1) {
							this.goodsHuaList()
							this.$message.success(res.msg)
						} else {
							this.$message.error(res.msg)
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(err => {
					console.log(err);
				});
			},
			changeGoodsStatus(item) {
				this.$confirm(`确认${item.status == 1 ? '下架' : '上架'}当前商品?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/Hua/sj_work', {
						id: item.id,
					}).then(res => {
						if (res.code == 1) {
							this.goodsHuaList()
							this.$message.success(res.msg)
						} else {
							this.$message.error(res.msg)
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(() => {

				});
			},
			naviToEdit(item) {
				this.$router.push({
					path: '/piblish',
					query: {
						id: item.id
					}
				})
			},
			changeAllWork(isAll) {
				this.checkAll = isAll
				this.data.map(item => item.check = true)
			},
			checkWater(item) {
				this.shuiYinOpts.forEach(row => {
					if (row.id == item.id) {
						row.check = true
						this.ruleForm.shuiyin = row.id
					} else {
						row.check = false
					}
				})
			},
			// 切换分类
			switchCategory(category) {
				this.activeCategory = category;
				this.checkAll = false
				this.goodsHuaList()
			},
			// 页码变化处理
			onPageChange(newPage) {
				this.currentPage = newPage
				this.goodsHuaList()
			},
			basicsLabelList() {
				this.$api.post('/Other/classify_list', {
					type: 1
				}).then(res => {
					if (res.code == 1) {
						this.typeOpts = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			basicsClassifyList() {
				this.$api.post('/Other/classify_list', {
					type: 2
				}).then(res => {
					if (res.code == 1) {
						this.yongtuOpts = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			basicsVipList() {
				this.$api.post('/Basics/vip_list', {}).then(res => {
					if (res.code == 1) {
						this.levelOpts = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			goodsHuaList() {
				let params = {
					p: this.currentPage,
					title: this.title,
					label: this.type
				}
				if (this.active) {
					params[this.active] = 1
				}
				this.data = []
				this.$api.post('/Hua/work_list', {
					top_where: this.activeCategory,
					cid: this.cid,
					yongtu: this.yongtu,
					level: this.level,
					shuxing: this.shuxing == '默认' ? '' : this.shuxing,
					px: this.px,
					p: this.currentPage,
					status: this.sj,
				}).then(res => {
					if (res.code == 1) {
						res.data.list.forEach(item => {
							this.data.push({
								...item,
								check: true
							})
						})
						this.total = res.data.count
					}
				}).catch(err => {
					console.log(err);
				})
			},
			changeFilter(type, value) {
				if (type == 'cid') {
					this.cid = value
				} else if (type == 'yongtu') {
					this.yongtu = value
				} else if (type == 'level') {
					this.level = value
				} else if (type == 'shuxing') {
					this.shuxing = value
				} else if (type == 'px') {
					this.px = value
				} else if (type == 'sj') {
					this.sj = value
				}
				this.goodsHuaList()
			},
			shuiyinList() {
				this.$api.post('/Other/shuiyin_list', {
					type: 2
				}).then(res => {
					if (res.code == 1) {
						res.data.forEach(item => {
							this.shuiYinOpts.push({
								...item,
								check: false,
							})
						})
					}
				}).catch(err => {
					console.log(err);
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.official-recommend-page {
		margin: .24rem .24rem;
		display: flex;
		flex-direction: column;
		background: #FFFFFF;
		border-radius: .08rem;
		padding: 0 .4rem .4rem;
	}

	.content-container {
		width: 12rem;
		display: flex;
		flex-direction: column;
	}

	/* 消息分类导航样式 */
	.msg-center-nav {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: .01rem solid rgba(204, 204, 204, .4);
	}

	.publish {
		width: .9rem;
		height: .36rem;
		background: #E29358;
		border-radius: .04rem;
		font-weight: 500;
		font-size: .12rem;
		color: #252525;
		line-height: .36rem;
		text-align: center;
		cursor: pointer;
	}

	.msg-categories {
		display: flex;
		gap: .32rem;
	}

	.category-item {
		font-weight: 400;
		font-size: .16rem;
		color: #040404;
		cursor: pointer;
		padding: .24rem 0 .15rem;
		position: relative;
		transition: color 0.3s ease;
	}

	.category-item:hover {
		font-weight: 500;
		font-size: .16rem;
		color: #6B3503;
	}

	.category-item.active {
		font-weight: 500;
		font-size: .16rem;
		color: #6B3503;
	}

	.category-item::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: .02rem;
		background-color: #693200;
		transform: scaleX(0);
		transform-origin: left center;
		transition: transform 0.3s ease;
	}

	.category-item.active::after {
		transform: scaleX(1);
	}

	.filterBox {
		display: flex;
		flex-direction: column;

		.filterItem {
			display: flex;
			font-size: .14rem;

			.filterItemTitle {
				margin-top: .16rem;
				height: .28rem;
				line-height: .28rem;
				width: .75rem;
				font-weight: 400;
				color: #000000;
			}

			.filterItemList {
				width: calc(100% - .75rem);
				display: flex;
				flex-wrap: wrap;

				.tip {
					margin-top: .16rem;
					margin-right: .24rem;
					height: .28rem;
					line-height: .28rem;
					font-weight: 400;
					color: #666666;
					cursor: pointer;

					&.active {
						color: #000000;
						padding: 0 .1rem;
						background: #E29358;
						box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
						border-radius: .06rem;
					}
				}
			}
		}
	}

	.chooseBox {
		margin-top: .24rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.choose {
			font-weight: 400;
			font-size: .14rem;
			color: #666666;
			cursor: pointer;
		}

		.watermark {
			display: flex;
			align-items: center;
			font-weight: 400;
			font-size: .14rem;
			color: #A88653;
			cursor: pointer;

			.arrow {
				width: .04rem;
				height: .08rem;
				margin-left: .04rem;
			}
		}
	}

	.officialList {
		display: flex;
		flex-direction: column;

		.workItem {
			margin-top: .24rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			cursor: pointer;

			.wokItemLeft {
				display: flex;
				align-items: center;

				.checkImg {
					margin-right: .32rem;
					width: .16rem;
					height: .16rem;
				}

				.workImgBox {
					display: flex;
					width: 1.2rem;
					height: 1.6rem;
					position: relative;

					.bestIcon {
						position: absolute;
						top: 0;
						left: 0;
						width: .34rem;
						height: .34rem;
					}

					.workImg {
						width: 1.2rem;
						height: 1.6rem;
						object-fit: cover;
						border-radius: .08rem;
					}
				}

			}

			.workInfoBox {
				display: flex;
				flex-direction: column;
				margin-left: .32rem;

				.title {
					display: flex;
					align-items: center;
					font-weight: 700;
					font-size: .24rem;
					color: #333333;
					line-height: .33rem;

					.topBox {
						margin-left: .08rem;
						display: flex;
						align-items: center;
						padding: 0 .08rem;
						border-radius: .11rem;
						font-weight: 400;
						font-size: .12rem;
						line-height: .22rem;
						cursor: pointer;

						.topIcon {
							width: .1rem;
							height: .1rem;
							margin-right: .02rem;
						}
					}

					.topBoxNor {
						color: #ACADB8;
						border: .01rem solid #ACADB8;
					}

					.topBoxOth {
						color: #F56C6C;
						border: .01rem solid #F56C6C;
					}

					.topBoxSel {
						color: #706614;
						border: .01rem solid #706614;
					}
				}

				.desc {
					margin-top: .12rem;
					height: .44rem;
					width: 5rem;
					font-size: .16rem;
					color: #333333;
					line-height: .22rem;
				}

				.tips {
					margin-top: .24rem;
					display: flex;
					align-items: center;

					.tip {
						margin-right: .1rem;
						height: .26rem;
						padding: 0 .08rem;
						border-radius: .13rem;
						border: .01rem solid #A88653;
						line-height: .24rem;
						font-weight: 400;
						font-size: .12rem;
						color: #7C3E0B;
					}

					.zanNum {
						font-weight: 400;
						font-size: .14rem;
						color: #666666;
					}
				}
			}

			.menu {
				display: flex;
				align-items: center;

				.menuItem {
					margin-left: .24rem;
					height: .4rem;
					border-radius: .06rem;
					font-weight: 400;
					font-size: .14rem;
					line-height: .4rem;
					text-align: center;
					cursor: pointer;
				}

				.edit {
					width: .92rem;
					color: #E29358;
					border: .01rem solid #E29358;
				}

				.details {
					width: 1.2rem;
					color: #E29358;
					border: .01rem solid #E29358;
				}

				.launch {
					width: .92rem;
					color: #706614;
					border: .01rem solid #706614;
				}

				.reEdit {
					width: 1.2rem;
					color: #706614;
					border: .01rem solid #706614;
				}

				.delete {
					color: #E29358;
				}
			}
		}
	}

	.reportDialog {

		::v-deep .el-dialog {
			width: 6rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;

				.tips {
					display: flex;
					align-items: center;
					font-weight: 500;
					font-size: .14rem;
					color: #312C28;
					line-height: .2rem;
				}

				.avatarName {
					display: flex;
					align-items: center;

					.avatar {
						margin-right: .08rem;
						width: .4rem;
						height: .4rem;
						border-radius: 50%;
						overflow: hidden;
						object-fit: cover;
					}

					.name {
						font-weight: 500;
						font-size: .14rem;
						color: #312C28;
					}
				}

				.reportContent {
					position: relative;

					.textNum {
						position: absolute;
						right: .12rem;
						bottom: .12rem;
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .14rem;
						color: #999999;
						line-height: .2rem;

						span {
							color: #252525;
						}
					}
				}

				.imgList::-webkit-scrollbar {
					width: 0;
					height: 0;
				}

				/* Firefox */
				.imgList {
					scrollbar-width: none;
					/* Firefox 隐藏滚动条 */
				}

				/* IE / Edge 老版本 */
				.imgList {
					-ms-overflow-style: none;
					/* IE11, Edge */
				}

				.imgList {
					display: flex;
					flex-direction: column;
					max-height: 5.4rem;
					width: 100%;
					overflow-y: auto;

					.imgItem {
						flex-shrink: 0;
						width: 4.24rem;
						height: .9rem;
						display: flex;
						align-items: center;
						justify-content: space-between;
						border-bottom: .01rem solid #CCCCCC;
						cursor: pointer;

						.imgBox {
							display: flex;
							align-items: center;
							font-weight: 400;
							font-size: .14rem;
							color: #252525;

							.waterImg {
								margin-right: .06rem;
								width: .6rem;
								height: .6rem;
								object-fit: cover;
								border-radius: .04rem;
							}
						}

						.checkImg {
							width: .16rem;
							height: .16rem;
						}
					}
				}

				.el-form {

					&-item:nth-child(2) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__label {
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__content {

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: 0 auto;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}

	li {
		font-size: .14rem !important;
		margin-bottom: 0;
	}
</style>